export default "__VITE_ASSET__mdoGrAy0__"